import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import epcisService from 'services/api/epcis.service';

// -------------------------------------------------------------------------

interface IEpcisSliceState {
    loading: boolean;
    error: IErrorModel | undefined;
    epcis: []
}

const initialState: IEpcisSliceState = {
    loading: false,
    error: {} as IErrorModel,
    epcis: [],
};

// -------------------------------------------------------------------------

export const getEpcisThunk = createAsyncThunk<
    IPaginatedResponse,
    {
        size: number; page: number,
        email: string;
        ndcCode: string;
        lotNumber: string;
        itemName: string;
        expiredOnly: boolean;
        startDate: string;
        endDate: string;
    },
    { rejectValue: IErrorModel }
>(`/epcis/getEpcis`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await epcisService.getEpcis(params);
        return response.data.epcis;
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch epcis data', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------


const epcisSlice = createSlice({
    name: `epcis`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Epcis
        builder.addCase(getEpcisThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getEpcisThunk.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.epcis = action.payload;
        });
        builder.addCase(getEpcisThunk.rejected, (state, action) => {
            state.loading = false;
            state.epcis = [];
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default epcisSlice;
export const epcisReducer = epcisSlice.reducer;

